module.exports = __webpack_public_path__ + "static/media/FMB_icon4.0b4813f5.svg";